import React, { useState, createContext, useContext } from 'react';
import { mockUser, familyMembers, professionals, Professional } from '../data/mockData';
type AuthState = 'unauthenticated' | 'authenticated';
interface AppContextType {
  authState: AuthState;
  setAuthState: (state: AuthState) => void;
  user: typeof mockUser | null;
  activeFamilyMemberId: string;
  setActiveFamilyMemberId: (id: string) => void;
  selectedProfessional: Professional | null;
  setSelectedProfessional: (prof: Professional | null) => void;
  bookingData: any;
  setBookingData: (data: any) => void;
}
const AppContext = createContext<AppContextType | undefined>(undefined);
export function AppProvider({
  children
}: {
  children: ReactNode;
}) {
  const [authState, setAuthState] = useState<AuthState>('unauthenticated');
  const [user, setUser] = useState<typeof mockUser | null>(mockUser);
  const [activeFamilyMemberId, setActiveFamilyMemberId] = useState(familyMembers[0].id);
  const [selectedProfessional, setSelectedProfessional] = useState<Professional | null>(null);
  const [bookingData, setBookingData] = useState<any>({});
  return <AppContext.Provider value={{
    authState,
    setAuthState,
    user,
    activeFamilyMemberId,
    setActiveFamilyMemberId,
    selectedProfessional,
    setSelectedProfessional,
    bookingData,
    setBookingData
  }} data-id="element-98">
      {children}
    </AppContext.Provider>;
}
export function useAppContext() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
}